var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "289.857 91.573 18 22",
    width: 18,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 305.857 93.573 L 301.677 93.573 C 301.257 92.413 300.157 91.573 298.857 91.573 C 297.557 91.573 296.457 92.413 296.037 93.573 L 291.857 93.573 C 290.757 93.573 289.857 94.473 289.857 95.573 L 289.857 111.573 C 289.857 112.673 290.757 113.573 291.857 113.573 L 305.857 113.573 C 306.957 113.573 307.857 112.673 307.857 111.573 L 307.857 95.573 C 307.857 94.473 306.957 93.573 305.857 93.573 Z M 298.857 93.573 C 299.407 93.573 299.857 94.023 299.857 94.573 C 299.857 95.123 299.407 95.573 298.857 95.573 C 298.307 95.573 297.857 95.123 297.857 94.573 C 297.857 94.023 298.307 93.573 298.857 93.573 Z M 305.857 111.573 L 291.857 111.573 L 291.857 95.573 L 293.857 95.573 L 293.857 98.573 L 303.857 98.573 L 303.857 95.573 L 305.857 95.573 L 305.857 111.573 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.165ff2a9.svg";
export { ForwardRef as ReactComponent };